import {
  Button,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  Select,
  Option,
  Form,
  FormItem,
  Card,
  Upload,
  Message
} from 'element-ui'
// css样式还是需要全部引入
import 'element-ui/lib/theme-chalk/index.css'

const element = {
  install: function (Vue) {
    Vue.use(Button)
    Vue.use(Menu)
    Vue.use(Submenu)
    Vue.use(MenuItem)
    Vue.use(MenuItemGroup)
    Vue.use(Input)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Card)
    Vue.use(Upload)
    Vue.prototype.$message = Message
  }
}

export default element
